'use client'
import React, { useState } from 'react'
import { FormProvider } from 'react-hook-form';
import { useFormConfig } from './hooks/useFormConfig';
import RenderForm from './RenderForm';

// Separate component for React Hook Form mode to avoid conditional hook calls
const RenderFormWithRHF = ({
  title,
  formSections,
  allFields,
  optionsMap = {},
  submitLabel = 'Submit',
  onSubmit = (data, e) => { },
  readOnly = false,
  basicForm = false,
  activeTab,
  setActiveTab,
  totalTabs,
  allTabData,
  schema,
  customValidation,
  formConfig,
  initialData = null,
  hideSave,
}) => {
  const [submitAttempted, setSubmitAttempted] = useState(false)
  const formMethods = useFormConfig(allFields, formConfig, schema, initialData, customValidation);

  return (
    <FormProvider {...formMethods}
      submitAttempted={submitAttempted}
      setSubmitAttempted={setSubmitAttempted}
    >
      <RenderForm
        title={title}
        formSections={formSections}
        allFields={allFields}
        optionsMap={optionsMap}
        formData={formMethods.formData}
        setFormData={formMethods.setValue}
        errors={formMethods.errors}
        setErrors={() => { }} // Not needed with RHF
        validateForm={formMethods.validateForm}
        submitLabel={submitLabel}
        hasUnsaved={formMethods.hasUnsaved}
        setHasUnsaved={() => { }} // Not needed with RHF
        readOnly={readOnly}
        basicForm={basicForm}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        totalTabs={totalTabs}
        allTabData={allTabData}
        onSubmit={onSubmit}
        useRHF
        hideSave={hideSave}
      />
    </FormProvider>
  );
};

export default RenderFormWithRHF;